import script from "./Pepn.vue?vue&type=script&setup=true&lang=js"
export * from "./Pepn.vue?vue&type=script&setup=true&lang=js"

import "./Pepn.vue?vue&type=style&index=0&id=ad90bde2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad90bde2"]])

export default __exports__